
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import config from '../../../config';

import { format, parseISO } from 'date-fns';
import { getIconForTransfer } from '../../../utils';


import LoadingMain from '../../../components/LoadingMain';
import CreateSyncModel from '../../sync/createSyncModel';


import { ErrorMessage, Field } from '../../../catalyst/fieldset';
import { Heading, Subheading } from '../../../catalyst/heading';
import { Text } from '../../../catalyst/text';

import { ArrowPathIcon, EllipsisVerticalIcon } from '@heroicons/react/16/solid';
import { useNavigate } from 'react-router-dom';
import { Badge, BadgeButton } from '../../../catalyst/badge';
import { Button } from '../../../catalyst/button';
import { Divider } from '../../../catalyst/divider';
import { Dropdown, DropdownButton, DropdownItem, DropdownMenu } from '../../../catalyst/dropdown';
import { Strong } from '../../../catalyst/text';

import PremiumPopupForSync from '../../premium/premiumPopupForSync';

export default function TransferHistory() {

  const navigate = useNavigate();


  const [loading, setLoading] = useState(true); // State to track loading state
  const [transfers, setTransfers] = useState([])

  const params = new URLSearchParams(window.location.search);
  const [redirectMessage, setRedirectMessage] = useState(params.get('message'))


  const [createSyncModelOpen, setCreateSyncModelOpen] = useState(false)
  const [transferHistoryToCreateSync, setTransferHistoryToCreateSync] = useState({})


  const [showPremiumPopupForSync, setShowPremiumPopupForSync] = useState(false)



  const [errResponse, setErrResponse] = useState("")

  const fetchData = async () => {
    try {
      setLoading(true); // Set loading state to true
      setErrResponse("")
      const response = await fetch(config.apiUrl + "/transfer/history", {
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
        }
      });

      const status = await response.status;
      if (status === 200) {
        let data = await response.json()
        setTransfers(data["transfers"])
      } else {
        throw new Error('Failed to get transfers. Please try again or contact us.');
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      setErrResponse("Failed to get transfer history. Please try again or contact us.")
    } finally {
      setLoading(false); // Set loading state to false after fetch completes
    }
  };

  useEffect(() => {


    fetchData();
  }, []);


  const handleRefresh = () => {
    if (redirectMessage === null) {
      setTransfers([])
      fetchData()
    } else {
      window.location.href = config.transferHistoryPath;
    }
  };



  const getMissingListViewitem = (missingLog, transferId) => {
    
    let actualMissed = 0;

    let listItems = missingLog.map(log => {
      if (log.length > 0) {
        actualMissed++;
        return <li key={log}>{log}</li>
      }
    });
    if(actualMissed == 0) {
      return <></>
    }
    return <><Subheading>Missed tracks</Subheading><ol>{listItems}</ol></>;
  }

  function getCollectionName(transfer) {
    return (
      <>
        <div className="flex items-center">
          {getIconForTransfer(transfer.sourceAccountType, transfer.isSourceYTM)}
          <span className="mx-2">to</span>

          {getIconForTransfer(transfer.destinationAccountType, transfer.isDestYTM)}
        </div>

        <Strong>
          {transfer.sourcePlayListType === "liked"
            ? "Liked/Saved Songs Transfer"
            : transfer.sourcePlayListType === "album"
              ? "Albums transfer"
              : " " + transfer.playlistName}
        </Strong>
      </>
    )
  }


  function getStartDate(transfer) {
    return (
      format(parseISO(transfer.createdAt), "eeee, MMMM do, yyyy 'at' h:mm a")
    )
  }

  function getCollectionType(transfer) {
    if (transfer.sourcePlayListType === "liked") {
      return (
        <Text>
          {"Liked songs"}
        </Text>
      )
    }
    if (transfer.sourcePlayListType === "album") {
      return (
        <Text>
          {"Album"}
        </Text>
      )
    }
    if (transfer.sourcePlayListType === "playlist") {
      return (
        <Text>
          {"Playlist"}
        </Text>
      )
    }
  }

  function getTransferStatus(transfer) {
    if (transfer.jobStatus === "CREATED") {
      return (
        <Text>
          {"Reading tracks, we will email you once completed"}
        </Text>
      )
    }
    if (transfer.jobStatus === "RUNNING") {
      return (
        <Text>
          {"Checking for matches, we will email you once completed"}
        </Text>
      )
    }
    if (transfer.jobStatus === "ERROR") {
      return (
        <Text>
          {"Error"}
        </Text>
      )
    }
    if (transfer.jobStatus === "COMPLETED_WITH_MISSING") {
      return (
        <Text>
          {"Completed with missing"}
        </Text>
      )
    }
    if (transfer.jobStatus === "COMPLETED_REPLACED") {
      return (
        <Text>
          {"Completed and replaced missed ones"}
        </Text>
      )
    }
    if (transfer.jobStatus === "COMPLETED") {
      return (
        <Text>
          {"Completed"}
        </Text>
      )
    }
    if (transfer.jobStatus === "SAVED") {
      return (
        <>
        <Text>
          {"Saved"}
        </Text>
        <div className="mt-2">
          <BadgeButton color="lime">Confirm Matches & Transfer</BadgeButton>
        </div>
        </>
      )
    }
    if (transfer.jobStatus === "EXPIRED") {
      return (
        <Text>
          {"Expired"}
        </Text>
      )
    }
  }


  function getCompletionStatus(transfer) {

    if(transfer.jobStatus === "SAVED") {
      return (
        <Text>
          <Link to={`${config.transferHistoryPath}/${transfer.id}/complete`}>Complete Transfer</Link>
        </Text>
      )
    }

    
    return (
      <Text>
        {transfer.transferredCount}/{transfer.totalCount}
      </Text>
    )
  }

  function getTransferStatusDropdown(transfer) {

    let dropdownItemsCount = 0;
    if (transfer.jobStatus === "COMPLETED_WITH_MISSING") {
      dropdownItemsCount++;
    }
    if (transfer.jobStatus === "SAVED") {
      dropdownItemsCount++;
    }
    if (transfer.syncId != null && transfer.syncId > 0) {
      dropdownItemsCount++;
    }
    if (transfer.canCreateNewSync) {
      dropdownItemsCount++;
    }
    if (dropdownItemsCount === 0) {
      return <></>;
    } else {
      return (
        <>
          <Dropdown>
            <DropdownButton plain aria-label="More options">
              <EllipsisVerticalIcon />
            </DropdownButton>
            <DropdownMenu anchor="bottom end">
              {transfer.jobStatus === "COMPLETED_WITH_MISSING" ? <><DropdownItem component={Link} href={`${config.transferHistoryPath}/${transfer.id}/edit`} >Add missing tracks</DropdownItem></> : ""}
              {transfer.jobStatus === "SAVED" ? <><DropdownItem component={Link} href={config.transferHistoryPath + "/" + transfer.id + "/complete"} underline="hover">Confirm Matches & Transfer</DropdownItem></> : ""}
              {transfer.syncId != null && transfer.syncId > 0 ? <DropdownItem component={Link} href={`${config.syncPath}/${transfer.syncId}`} >View Sync</DropdownItem> : <></>}
              {transfer.canCreateNewSync ? <DropdownItem onClick={() => { setTransferHistoryToCreateSync(transfer); setCreateSyncModelOpen(true) }} >Create Sync</DropdownItem> : <></>}
            </DropdownMenu>
          </Dropdown>
        </>
      );
    }

  }

  function HistoryTable() {
    return (

      <>
        <PremiumPopupForSync setShowPremiumPopupForSync={(flag) => setShowPremiumPopupForSync(flag)} showPremiumPopupForSync={showPremiumPopupForSync} ></PremiumPopupForSync>
        <CreateSyncModel setShowPremiumPopupForSync ={(flag) => setShowPremiumPopupForSync(flag)} transferHistory={transferHistoryToCreateSync} createSyncModelOpen={createSyncModelOpen} setCreateSyncModelOpen={(flag) => setCreateSyncModelOpen(flag)}></CreateSyncModel>


        {transfers.length === 0 ?

          (<div className="flex flex-col justify-center items-center"><Text className="pb-4">{errResponse ? <Field><ErrorMessage>{errResponse}</ErrorMessage></Field> : 'No recent playlists transfers.'}</Text><Link to={config.accountsPath}><Button>Start Transfer</Button></Link></div>)
          : (
            <>
              <div className="flex flex-wrap items-end justify-between gap-4">
                <div className="max-sm:w-full sm:flex-1">
                  <Heading>Transfer History</Heading>
                </div>
                <Link to={config.accountsPath}><Button>New Transfer</Button></Link>
                <Button onClick={handleRefresh}>
                  <ArrowPathIcon />Refresh
                </Button>
              </div>

              {redirectMessage === "TRANSFER_STARTED" ? <Badge color="lime" >Your transfers are queued for processing. We will email you once completed.</Badge> : <></>}

              {redirectMessage === "MISSING_REPLACED" ? <Badge color="lime" >All missing songs have been added to your playlist/album.</Badge> : <></>}



              <ul className="mt-10">
                {transfers.map((transfer, index) => (
                  <li key={transfer.id}>
                    <Divider soft={index > 0} />
                    <div className="flex items-center justify-between">
                      <div key={transfer.id} onClick={() => { if (transfer.jobStatus === "SAVED") { navigate(`${config.transferHistoryPath}/${transfer.id}/complete`) } }} className="flex gap-6 py-6">


                        <div className="space-y-1.5">
                          <div className="text-base/6 font-semibold text-zinc-950 dark:text-white">
                            <Link to={"#"}><>{getCollectionName(transfer)}</></Link>
                          </div>
                          <div className="text-xs/6 text-zinc-500">
                            Transfer on {getStartDate(transfer)}
                          </div>
                          <div className="text-xs/6 text-zinc-500">
                            {getCollectionType(transfer)}
                          </div>
                        </div>


                        <div className="space-y-1.5 text-zinc-950 dark:text-white ">
                          <div className="text-xs/6">
                            {getCompletionStatus(transfer)}
                          </div>
                          <div className="text-xs/6">
                          {getTransferStatus(transfer)}
                          </div>
                        </div>


                      </div>
                      
                      <div className="flex items-center gap-4">
                        {getTransferStatusDropdown(transfer)}
                      </div>
                    </div>


                    <div className="space-y-1.5 text-zinc-950 dark:text-white">
                          <div className="text-xs/6">
                            {transfer.missedLog === null ? transfer.missedLog : getMissingListViewitem(transfer.missedLog.split("\n"))}
                          </div>
                    </div>

                  </li>
                ))}
              </ul>
            </>
          )
        }


      </>
    )
  }

  return (

    <>
      {loading ? <LoadingMain />
        : <><HistoryTable></HistoryTable></>
      }
    </>
  );

};

